import api from './axiosConfig';

export interface FetchHVASearchCallsParams {
  service?: string;
  campaign?: string;
  hva?: string;
  firstName?: string;
  lastName?: string;
  accountID?: string;
  customerID?: string;
  phoneNumber?: string;
  startDate?: string;
  endDate?: string;
}

export const fetchHVASearchCalls = async (
  params: FetchHVASearchCallsParams
) => {
  try {
    const response = await api.post('hvacalls/searchcalls', params);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch HVA search calls:', error);
    throw error;
  }
};
